import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void { }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    //   Here, you can implement your logic to decide whether to reuse the route or not.
    //   For now, it always returns false, meaning it won't reuse routes.
    // if (!future.routeConfig?.path) {
    //   console.log(' =========================================================== ');
    //   console.log('future ==> ', future['_routerState']);
    //   console.log(' =========================================================== ');
    // }

    //const path = future.routeConfig?.path ?? null;

    const routes = [
      'companies',
      'companiesList',
      'dashboard',
      'documents',
      'gantt',
      'measures',
      'measureDetail/:from/:id',
      'reports',
      'roles',
      'subProject',
      'subProjectDetail/:id',
      'tasks',
      'trainingCenter',
      'project',
      'staffMembers',
      'roleRights',
      'login',
      'select-profile',
      'landing-page',
      'forgot-password',
      'reset-password/:id',
      'register/:id',
      'notification'
    ];

    const currentPath = curr.routeConfig?.path;
    const futurePath = future.routeConfig?.path;

    if (
      routes.includes(futurePath) ||
      (futurePath === '' && (currentPath === 'select-profile' || currentPath === 'login'))
    )
      return false;

    return true;
  }
}
